function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff"
}), React.createElement("path", {
  d: "M40.5,38.08l-20,1.42a10,10,0,0,1-10-10h0a10,10,0,0,1,10-10l20,1.42c5.52,0,10,3.06,10,8.58h0C50.5,35,46,38.08,40.5,38.08Z",
  fill: "#adafb5",
  stroke: "#adafb5",
  strokeMiterlimit: 10
}), React.createElement("circle", {
  cx: 20.5,
  cy: 29.5,
  r: 10,
  fill: "#adafb5",
  stroke: "#fff",
  strokeMiterlimit: 10
}), React.createElement("circle", {
  cx: 20,
  cy: 30,
  r: 7,
  fill: "#fff"
})));

function SvgPipe(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/pipe.616e9fc2.svg";
export { SvgPipe as ReactComponent };